module.exports = __webpack_public_path__ + "media/svg-new/crying-608aa35d.svg";